<template>
  <v-charts ref="echarts" :options="option" autoresize  :style="styleObj" @click="echartClick"/>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/title'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/gauge'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/legend'
export default {
  props: {
    option: {
      type: Object,
      default: () => ({})
    },
    styleObj: {
      type: Object,
      default: () => ({})
    }
  },
  components: { 'v-charts': ECharts },
  methods: {
    echartClick(e) {
      this.$emit('echartClick', e)
      console.log(e)
    },
    // 自适应
    echartsResize() {
      this.$refs.echarts.resize();
    }
  }
}
</script>
